export function getRelativeUrl(url: string) {
    const urlInstance = new URL(url);
    return urlInstance.pathname + urlInstance.search + urlInstance.hash;
}